export default __webpack_public_path__ + "static/impact-hero-white-1-2142912bb2006216761a389b996a53dd.svg";